<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      round
      highlight-hover-row
      :height="tableHeight - 4"
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumn"
      :loading="loading"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      row-id="prjCode"
    >
      <template v-slot:prjtitle="{ row }">
        <span style="font-size: 14px; font-weight: 400">{{
          row.custName ? row.custName : '--'
        }}</span>
        <br />
        <span style="font-size: 14px; font-weight: 400">{{
          row.prjTitle ? row.prjTitle : '--'
        }}</span>
        <br />
        <span>
          <small
            >{{ $l('label_period') || '项目周期' }}：{{ row.beginDate }}-{{
              row.endDate
            }}</small
          >
        </span>
      </template>

      <template v-slot:status="{ row }">
        <b-badge
          :variant="
            row.prjStatus === 'Y'
              ? 'success'
              : row.prjStatus === 'P'
              ? 'info'
              : row.prjStatus === 'D'
              ? 'danger'
              : row.prjStatus === 'C'
              ? 'warning'
              : row.prjStatus === 'F'
              ? 'secondary'
              : row.prjStatus === 'S'
              ? 'secondary'
              : ''
          "
        >
          {{
            row.prjStatus === 'Y'
              ? $l('label_completed') || '已完成'
              : row.prjStatus === 'P'
              ? $l('label_in_progress') || '进行中'
              : row.prjStatus === 'D'
              ? $l('label_out_dated') || '已超期'
              : row.prjStatus === 'C'
              ? $l('label_terminated') || '已终止'
              : row.prjStatus === 'F'
              ? $l('label_deleted') || '已删除'
              : row.prjStatus === 'S'
              ? $l('label_draft') || '草稿'
              : ''
          }}
        </b-badge>
        <b-badge
          class="ml-1 mb-1"
          :variant="row.prjTypeFlag === 'Y' ? 'secondary' : 'danger'"
        >
          {{
            row.prjTypeFlag === 'Y'
              ? $l('label_prjTypeFlagMain') || '主项目'
              : $l('label_prjTypeFlagSub') || '子项目任务'
          }}
        </b-badge>
        <b-progress
          :variant="
            row.prjStatus === 'Y'
              ? 'success'
              : row.prjStatus === 'P'
              ? 'info'
              : row.prjStatus === 'D'
              ? 'danger'
              : row.prjStatus === 'C'
              ? 'warning'
              : row.prjStatus === 'F'
              ? 'secondary'
              : row.prjStatus === 'S'
              ? 'secondary'
              : ''
          "
          height="0.4rem"
          style="width: 250px"
          :value="row.prjSchedule"
          :max="max"
          animated
        ></b-progress>
        <p style="font-size: 13px">Completion with: {{ row.prjSchedule }}%</p>
      </template>

      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
            v-if="row.prjStatus !== 'F'"
          >
            <i
              class="el-icon-view tool-btn"
              @click="$emit('fromLoad', { ref: 'detail', val: row.prjCode })"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="$emit('fromLoad', { ref: 'edit', val: row.prjCode })"
              v-if="allow('M')"
              v-show="row.prjStatus !== 'F'"
            ></i>
          </el-tooltip>

          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_copy') || '复制'"
            placement="top"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="copyPrj(row)"
              v-if="allow('C')"
            ></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:team="{ row }">
        <b-avatar-group size="2rem" overlap="0.15">
          <b-avatar
            v-for="(item, index) in row.teamPhotoList"
            :key="index"
            :src="item.memberImgUrl"
            v-b-tooltip.hover
            :title="item.memberUserName"
          ></b-avatar>
        </b-avatar-group>
      </template>

      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tablePage: { type: Object, default: () => {} },
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      max: 100,
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('submit') },
        zoom: true,
        custom: true,
      },
      tableColumn: [
        {
          field: 'seq',
          width: 60,
          fixed: 'left',
          align: 'center',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'center',
          fixed: 'right',
          width: 120,
          slots: { default: 'opt' },
        },
        {
          field: 'prjTitle',
          minWidth: 300,
          title: this.$l('table_label_projectName') || '项目名称',
          headerAlign: 'left',
          align: 'left',
          showHeaderOverflow: 'title',
          slots: { default: 'prjtitle' },
        },
        {
          field: 'prjStatus',
          minWidth: 300,
          title: this.$l('table_label_schedule') || '整体进度',
          headerAlign: 'left',
          align: 'left',
          showHeaderOverflow: 'title',
          slots: { default: 'status' },
        },
        {
          field: 'teamPhotoList',
          minWidth: 300,
          title: this.$l('table_label_projectTeam') || '项目团队',
          headerAlign: 'left',
          align: 'left',
          showHeaderOverflow: 'title',
          slots: { default: 'team' },
        },
      ],
    }
  },
  methods: {
    async copyPrj({ prjCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_copyPrj') || '是否要复制该项目？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .projectInfoCopyApi({ prjCode })
        .catch(() => false)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_copy_error') || '复制失败！')
        return
      }

      this.$router.push({
        name: 'projectManagement-projectInfo-edit',
        params: {
          pageType: 'edit',
          prjCode: body,
        },
      })
    },
  },
}
</script>
